/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The current state of the meet workspace.

- `active`: SAML cert is healthy and bots can sign in
- `invalid`: System auto-flipped this on a SAML rejection. Manual re-enable required.
 */
export type CreateMeetWorkspace201DataState =
  (typeof CreateMeetWorkspace201DataState)[keyof typeof CreateMeetWorkspace201DataState]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateMeetWorkspace201DataState = {
  active: "active",
  invalid: "invalid"
} as const
